import { HttpEvent, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { tap } from "rxjs";
import { inject } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";

export const httpInterceptor: HttpInterceptorFn = (req, next) => {

  const ngxSpinnerService = inject( NgxSpinnerService );
  ngxSpinnerService.show();

  return next(req)
    .pipe(
      tap(async (event: HttpEvent < any > ) => {
        if (event instanceof HttpResponse) {
          await ngxSpinnerService.hide();
        }
      },
      () => {
        ngxSpinnerService.hide();
      })
    );
};
